import React, { ComponentProps } from "react";

export default function EllipseIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
      {...props}
    >
      <ellipse
        cx="5.33825"
        cy="4.06361"
        rx="3"
        ry="6"
        transform="rotate(58.1578 5.33825 4.06361)"
        fill={props.fill}
      />
    </svg>
  );
}
